import React, { useState, useMemo } from "react";
import { TransactionsController } from "../../controllers";
import { KudaTransactions } from "../../pages";

const KudaTransactionsContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const kudaTranTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    TransactionsController.useGetKudaTransactions(
      kudaTranTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const filterHandler = async (query) => {
    setFilterQuery(query);
  };

  return (
    <KudaTransactions
      filterHandler={filterHandler}
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
    />
  );
};

export default KudaTransactionsContainer;
